import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'

const Section = styled.section`
  min-height: ${props => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${props => props.theme.body};
`

const Container = styled.div`
  width: 80%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    // text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1{
      color: blue;
  }
  .text-2{
      color: orange;
      font-size: 24px;
  }
  .text-3{
      color: red;
  }
  .small{
      font-size: 36px;
  }
  .smaller{
      font-size: 24px;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};

  }
  @media (max-width: 48em) { 
    align-self: center;
    text-align: center;
    .smaller{
      font-size: 24px;
      margin-top: 30px;
    }
  }
  @media (max-width: 40em){
    width: 90%;
    
    .smaller{
      font-size: 24px;
      margin-top: 30px;
    }
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${props => props.theme.fontlg};
    font-weight: 600;
    margin-bottom: 0;
  }
    p span {
        color: orange;
    }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align:center;
  }
`

const Div2 = styled.div`
    font-size: 20px;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 50px;
    p {
        color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
        font-size: ${props => props.theme.fontlg};
        font-weight: 600;
        margin-top: 10px;
    }
    button {
        margin: 10px 0;
        width: 100%;
        padding: 20px;
        border-radius: 20px;
        background-color: black;
        color: white;
        border: none;
        cursor: pointer;
    }
    @media (max-width: 64em) {
      width: 85%;
      flex-direction: column;
    }
    @media (max-width: 48em) {
      width: 85%;
      flex-direction: column;
      align-self: center;
      text-align: center;
      margin-bottom: 50px;
      
      .small {
        font-size: 30px;
        line-height: 10px;
      }
      p {
          margin-top: 20px;
          font-size: 18px;
      }
    }
`
const BlockDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;

    .block {
        img{
            width: 60px;
            margin-right: 20px;
        }
        margin-top: 50px;
        width: 45%;
        height: 100px;
        display: flex;
        padding: 0 20px;
        justify-content: flex-start;
        align-items: center;
        font-size: 24px;
        color: #333;
        border: 1px solid;
        border-image: linear-gradient(to right, grey, transparent) 1;
        border-image-slice: 1; /* ✅ Important */
        border-radius: 10px;
    
        &:hover {
            border-image: none;
            border-color: orange;
            transition: all 0.3s ease;
        }
    }
  @media (max-width: 64em) {
    width: 85%;
    .block {
      width: 100%;
      margin-top: 30px;
      height: 80px;
      font-size: 16px;
  }
    .smaller {
      margin-top: 20px;
    }
  }
  @media (max-width: 48em) { 
    width: 100%;
    .block {
      width: 100%;
      margin-top: 30px;
      height: 80px;
      font-size: 16px;
    }
    h2 {
      margin-top: 30px;
    }
  }
`

const ConnectPage = () => {
  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <Div>
            <Title>
                <span >Connect Wallet</span>
            </Title>
            <p> 
                <Link to="/">Home</Link>
                 
                <span> . Connect Wallet</span>
            </p>
        </Div>

        <Div2>
            <Title>
                <span className='small' >You need an Ethereum wallet to use trade millennia</span>
            </Title>
            <p> 
                <span>Connect with one of our available wallet providers</span>
            </p>

            <BlockDiv>
                <Link to="/login" className='block'>
                    <img src={"https://trevomint.com/static/media/user-login.4ce1ce10ce20ffcefb44.png"} alt="logo" />
                    Username and Password
                </Link>
                <Link to="/manual-connect" className='block'>
                    <img src={"https://trevomint.com/static/media/walletconnect.d9060b0de42773291c32.webp"} alt="logo" />
                    Connect Manually
                </Link>

                <Title>
                    <span className='smaller' >New to Trade Millennia</span> 
                    <a href="/signup"> <span className="text-2">Register Here?</span>
                    </a>
                </Title>
                
            </BlockDiv>

        </Div2>
        <div>
           
        </div>
      </Container>
      <Footer />
    </Section>
  )
}

export default ConnectPage